<template>
  <section class="gfr-layout-main">
    <slot />
  </section>
</template>
<script lang="ts" setup></script>
<style scoped lang="postcss">
.gfr-layout-main {
  @apply flex-1 flex;
}
</style>
